import { z } from 'zod';

export const holidaysSchema = z
  .object({
    applyHolidayPremium: z.boolean().nullable().optional(),
    holidayCatalogIds: z.array(z.string().uuid()).nullable().optional(),
    holidayCustomIds: z.array(z.string().uuid()).nullable().optional(),
    holidayPremiumType: z.string().nullable().optional(),
    holidayOvertimeOffset: z.number().nullable().optional(),
    holidayFloorTierCode: z.string().nullable().optional(),
    holidayFloorTierCustomValue: z.number().nullable().optional(),
    holidayFixedPremiumAmount: z.number().nullable().optional(),
    holidayHourlyPremiumType: z.string().nullable().optional(),
    holidayHourlyPremiumValue: z.number().nullable().optional(),
  })
  .passthrough()
  .superRefine((data, ctx) => {
    if (!data.applyHolidayPremium) return;

    const catalogCount = data.holidayCatalogIds?.length ?? 0;
    const customCount = data.holidayCustomIds?.length ?? 0;
    if (catalogCount + customCount === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['holidayCatalogIds'],
        message: 'Please select at least one holiday when premium is enabled.',
      });
    }

    if (data.holidayPremiumType === 'offset_overtime') {
      const offset = data.holidayOvertimeOffset;
      if (offset == null || !Number.isInteger(offset) || offset < 1) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['holidayOvertimeOffset'],
          message: 'Offset amount must be a whole number of at least 1.',
        });
      }
    } else if (data.holidayPremiumType === 'guaranteed_rate') {
      if (!data.holidayFloorTierCode && !data.holidayFloorTierCustomValue) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['holidayFloorTierCode'],
          message: 'Select a floor multiplier or enter a custom rate.',
        });
      }
    }

    if (data.holidayPremiumType === 'fixed_dollar') {
      if (!data.holidayFixedPremiumAmount || data.holidayFixedPremiumAmount <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['holidayFixedPremiumAmount'],
          message: 'Premium amount must be greater than 0.',
        });
      }
    } else if (data.holidayPremiumType === 'hourly_premium') {
      if (!data.holidayHourlyPremiumType) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['holidayHourlyPremiumType'],
          message: 'Premium Type is required',
        });
      }
      if (
        data.holidayHourlyPremiumType === 'percentage' &&
        (!data.holidayHourlyPremiumValue || data.holidayHourlyPremiumValue <= 0)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['holidayHourlyPremiumValue'],
          message: 'Percentage must be greater than 0',
        });
      }
      if (
        data.holidayHourlyPremiumType === 'fixed' &&
        (!data.holidayHourlyPremiumValue || data.holidayHourlyPremiumValue <= 0)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['holidayHourlyPremiumValue'],
          message: 'Amount must be greater than 0',
        });
      }
    }
  });

export type HolidaysSchemaData = z.infer<typeof holidaysSchema>;
